import React from 'react';
import './contacts.sass';
import { Line } from '../../../line/line';
// import * as EmailValidator from 'email-validator';
// import * as firebase from 'firebase';
 
export type registrationFormStateTypes = {
    name: string
    email: string
    massage: string
}


export class RegistrationForm extends React.Component {
    state: registrationFormStateTypes = { 
        name: '', 
        massage: '',
        email: ''
    };

    handleChange = (input: any) => (e: { target: { value: any; }; }) => {
        this.setState({[input]: e.target.value});
    }
    
     handleChangeMassage = (e: any) => { 
        console.log(e.target.value);
        this.setState({massage: e.target.value});
    }
    
    handleSubmit = (e: React.MouseEvent) => 
    {
        alert("your message has been sent");
        e.preventDefault();
        const { name, email, massage } = this.state;
        const body = {
            field_1: name,
            field_2: email, 
            field_3: massage
        }
        fetch('/sendMail', {
            method: 'POST',
            body: JSON.stringify(body),

          })
            .then(response => {
              console.log(response.status);
            })
            .catch(err => {
                console.log(500);
            })
    }
    render(){

    return(
        <div className="Contacts">
            <div>
                {/* Contacts */}
                <h2 id="Contacts_h2">Контакты</h2>
                {/* <Components text="text " /> */}
                <Line />
                <div className="form_validation">
                    <input type="text" onChange={this.handleChange("name")} name="name"  placeholder="Name" id="form_validation_name" required/>
                    <br/>
                    <input type="email" onChange={this.handleChange("email")} name="email"  placeholder="Email" id="form_validation_email" required/>
                    <br/>
                    <textarea placeholder="Massage" name="name" onChange={this.handleChangeMassage} id="form_validation_massage" /> {/*15-19*/}
                    <br/>
                    <button id="form_validation_bttn" onClick={this.handleSubmit}>Aplly</button> {/* не ставвим () после addPost что-бы сразу не вызвалась */}
                </div>
            </div> 
        </div>
    )
}
}